/** @format */
import { create } from "zustand"

type ToastContent = {
	type: "success" | "warning" | "error"
	headerText: string
	message: string
}

type ToastState = {
	displayed: boolean
	progression: number
	content?: ToastContent
}

type ToastStore = {
	toastState: ToastState
	displayToast: (content: ToastContent) => void
	closeToast: () => void
}

export const TOAST_MAX_DURATION_MS = 5000

const useToast = create<ToastStore>((set, get) => {
	const intialState: ToastState = {
		content: null,
		displayed: false,
		progression: 0,
	}

	const closeToast = () => {
		set(({ toastState }) => ({
			toastState: { ...toastState, displayed: false },
		}))

		setTimeout(() => {
			set({ toastState: intialState })
		}, 250)
	}

	const displayToast = (content: ToastContent) => {
		set({
			toastState: {
				content,
				displayed: true,
				progression: 0,
			},
		})

		setTimeout(() => {
			set(({ toastState }) => ({
				toastState: {
					...toastState,
					progression: 100,
				},
			}))
		}, 0)

		setTimeout(() => {
			if (get().toastState.displayed) {
				closeToast()
			}
		}, TOAST_MAX_DURATION_MS)
	}

	return {
		toastState: intialState,
		displayToast,
		closeToast,
	}
})

export type { ToastContent }

export const displayToast = useToast.getState().displayToast
export default useToast
